import { combineTokens } from '@utils/css';

const props = combineTokens("--truncate", {
  maxLines: 3
});
const wrapper = "_ecwcivzjm";

export { props, wrapper };
import "./_truncate-lines.style.linaria.module.css";
//# sourceMappingURL=_truncate-lines.style.js.map
